
import { Layers } from "lucide-react";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <Link to="/" className="flex items-center gap-2 text-[#6B4EE6] hover:text-[#9B87F5] transition-colors">
      <Layers size={24} className="shrink-0" />
      <span className="font-bold text-lg hidden md:block">CardCombiner</span>
    </Link>
  );
};

export default Logo;
